export default "__VITE_ASSET__qmrD6bzO__"